import { AxiosResponse } from "axios";
import api from "../api/base-api";

const getAllTesterAppVersionDetails = (reportId: string): Promise<AxiosResponse> => {
    return api.get(`validation/application/${reportId}`);
};

const updateValidationSubStepStatus = (id: string, data: number): Promise<AxiosResponse> => {
    return api.put(`/validation/substep_status/${id}`, data);
};

const updateValidationStatus = (id: string, data: number): Promise<AxiosResponse> => {
    return api.put(`/validation/report_status/${id}`, data);
};

const addSubStepAttachment = (
    id: string,
    data: number,
    onProgress: (event: ProgressEvent<EventTarget>, data: unknown) => void
): Promise<AxiosResponse> => {
    return api.post(`/validation/substep_attachment/${id}`, data, {
        headers: {
            "Content-type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent: ProgressEvent) => onProgress(progressEvent, data),
    });
};

const deleteSubStepAttachment = (id: string): Promise<AxiosResponse> => {
    return api.delete(`/validation/document/${id}`);
};


const downloadSubStepAttachment = (id: string): Promise<AxiosResponse> => {
    return api.get(`/validation/document/${id}`);
};

const updateValidationComment = (id: string, data: number): Promise<AxiosResponse> => {
    return api.put(`/validation/report_status/${id}`, data);
};

const updateMediaStatus = (id: string, data: any): Promise<AxiosResponse> => {
    return api.put(`/validation/media/${id}`, data);
};

const updatePermissionValidation = (id: string, data: any): Promise<AxiosResponse> => {
    return api.put(`/validation/permission_validation/${id}`, data);
};

export {
    updateValidationSubStepStatus,
    getAllTesterAppVersionDetails,
    addSubStepAttachment,
    deleteSubStepAttachment,
    updateValidationStatus,
    downloadSubStepAttachment,
    updateValidationComment,
    updateMediaStatus,
    updatePermissionValidation,
};
